import _ from "lodash";
import { store } from "store/createStore";
import ACLStore from "lib/aclStore";
import { parseConfigurationValue } from "Utils";
import { generateConfigurationQueryVariablesMemoized } from "Login/components/ChildrenPage/modules/ChildrenPageUtils";
import { getConfigurationsFromCacheV2 } from "ChildrenPage/modules/ChildrenPageGraphqlHelpers";

const RTE_AI_ENABLED_PERMISSION = "FeatureFlag:EnableAIInAnnouncementRTE";

const isAiEnabledForAnnouncementInAdminPortal = () => {
  const state = store.getState();

  const curriculumProgramList = _.get(
    state,
    "platform.organizationCurriculumPrograms",
    []
  );

  const configurationQueryVariables = generateConfigurationQueryVariablesMemoized(
    {
      src: "ADMIN_PORTAL_HOME_PAGE",
      curriculumProgramList,
    }
  );

  const configurationResponse = getConfigurationsFromCacheV2(
    configurationQueryVariables
  );

  const isAiEnabledInSomeCourse = _.some(
    configurationResponse,
    curriculumConfig => {
      const configurations = _.get(curriculumConfig, "configurations", []);

      const aiEnabledCurriculumConfig = _.find(configurations, config =>
        _.isEqual(_.get(config, "configuration"), RTE_AI_ENABLED_PERMISSION)
      );
      const isAiEnabledCurriculumConfig = parseConfigurationValue(
        aiEnabledCurriculumConfig
      );
      return isAiEnabledCurriculumConfig;
    }
  );
  return isAiEnabledInSomeCourse;
};

export const getIsAIEnabledInAnnouncementModule = () => {
  const state = store.getState();

  const activeTab = _.get(state, "login.activeTab", "");
  const isFromAdminPage = activeTab === "admin";

  if (isFromAdminPage) {
    return isAiEnabledForAnnouncementInAdminPortal();
  }

  return ACLStore.can(RTE_AI_ENABLED_PERMISSION);
};
